import { omit } from "lodash";

export const racingsListByRegionSelector = data => {
	if (!data.region) return [];

	const list = [];

	for (const regionId in data.region) {
		const region = data.region[regionId];

		if (!region) continue;

		list.push({
			id: +region.id,
			name: region.name,
			alias: region.alias,
			competitions: Object.values(region.competition)
				.filter(comp => !!comp?.game)
				.map(comp =>
					omit(
						{
							...comp,
							games: Object.values(comp.game)
								.filter(game => !!game)
								.sort((a, b) => a.start_ts - b.start_ts),
						},
						["game"]
					)
				),
		});
	}

	return list;
};
